module.exports = __webpack_public_path__ + "static/41-156775f288dce002104704473237275e.jpg";